<template>
  <div class="partners" @mouseover="pause()" @mouseleave="start()">
    <div class="fx-height">
      <div class="list-item" :style="itemStyle" :key="0">
        <router-link :to="url" class="title" tag="div" >
          <div class="text">
            {{ 'OUR ' + name }}
          </div>
        </router-link>
      </div>

      <transition name="fade" mode="out-in">
        <PartnersItem :style="itemStyle" :item="random[0]" :key="random[0].photo" :index="0" />
      </transition>

      <transition name="fade" mode="out-in">
        <PartnersItem :style="itemStyle" :item="random[1]" :key="random[1].photo" :index="1" />
      </transition>

      <transition name="fade" mode="out-in">
        <PartnersItem  :style="itemStyle" :item="random[2]" :key="random[2].photo" :index="2" />
      </transition>
    </div>
  </div>
</template>

<script>

import PartnersItem from './PartnersItem.vue'
import completeLoad from '../mixins/completeLoad'
import $ from 'jquery'

export default {
  props: [ 
    'url',
    'name',
    'items'
  ],

  components: {
    PartnersItem
  },

  data () {
    return {
      random: [],
      live: true,
      itemStyle: {
        height: '100%'
      }
    }
  },

  mixins: [completeLoad],

  created () {
    for(let i in this.items) {
      this.imageLoad(this.items[i].photo, () => {
        this.setHeight()
      })
    }

    for(let i in this.items) {
      this.imageLoad(this.items[i].photo)
    }

    for (var i = 0; i < 3; i++) {
      this.random.push(this.items[i])
    }

    setInterval(() => { 
      this.setRandomItem()
    }, 3000);
  },

  mounted () {
    $(window).resize((e) => {
      this.setHeight()
    });
  },

  methods: {
    setHeight () {
      this.itemStyle.height = $('.partners .list-item img').height() + 20 + 'px'
    },

    setRandomItem () {
      if (!this.live) { return }

      var free = this.items.filter((item) => {
        for(let k in this.random) {
          if (this.random[k] === item) {
            return false
          }
        }

        return true
      })

      if (!free) { return }

      var key = this.getRandomInt(0, this.random.length);
      var keyFree = this.getRandomInt(0, free.length);
      this.$set(this.random, key, free[keyFree])
    },

    start () {
      this.live = true
    },

    pause () {
      this.live = false
    },

    // использование Math.round() даст неравномерное распределение!
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    }
  }
}
</script>